import type { IPropertyBag } from '@deity-io/di-data-basics';
import type { IRuntimeEnvironment } from 'contexts/UIContext';
import type { GetPackageVersionQuery } from 'services/graphql/generated/operations';

export type IConfigurationStore = {
  // Environment variables, like gatewayUrl
  env: IPropertyBag;
  // in a run, the current IMessage
  message: IPropertyBag;
  // The variables set on the packageVersion
  variables: IPropertyBag;
};

/**
 * Builds a IConfigurationStore to pass config/env data for testing
 * @param currentEnvironment  : IRuntimeEnvironment
 * @param packageVersionData  : GetPackageVersionQuery
 * @returns
 */
export const buildConfigurationStore = (
  currentEnvironment: IRuntimeEnvironment | undefined,
  packageVersionData: GetPackageVersionQuery | undefined
): IConfigurationStore => {
  if (packageVersionData && currentEnvironment) {
    return {
      env: { ...(currentEnvironment.variables || {}) },
      message: {},
      variables: {
        ...(packageVersionData.getPackageVersion.variables[currentEnvironment.name || ''] || {})
      }
    };
  }

  return {
    env: {},
    message: {},
    variables: {}
  };
};
